import { getPrescriptionEntryList } from "./get-prescription-entry-list.js";
function getConfiguratorDocument(content, noAddonsImage) {
  if (!content) {
    return {
      addOnsStep: {
        noAddonsImage
      },
      prescriptionStep: {},
      prescriptionUploadStep: {},
      packageStep: {}
    };
  }
  const {
    addOnStepReadMore,
    packageStepReadMore,
    prescriptionStepDescription,
    prescriptionStepImage,
    prescriptionStepEntryTypes,
    prescriptionStepMeasure,
    prescriptionStepRead
  } = content;
  const entryTypes = getPrescriptionEntryList(prescriptionStepEntryTypes);
  return {
    prescriptionStep: {
      entryTypes,
      measureDescription: prescriptionStepMeasure?.description?.value ?? void 0,
      readDescription: prescriptionStepRead?.description?.value ?? void 0
    },
    prescriptionUploadStep: {
      description: prescriptionStepDescription?.value,
      image: prescriptionStepImage
    },
    packageStep: {
      readMoreLink: !!packageStepReadMore?.url ? packageStepReadMore : void 0
    },
    addOnsStep: {
      readMoreLink: !!addOnStepReadMore?.url ? addOnStepReadMore : void 0,
      noAddonsImage
    }
  };
}
export {
  getConfiguratorDocument
};
//# sourceMappingURL=get-configurator-document.js.map
